import { TFunction } from "i18next";
import * as yup from "yup";
import { InferType } from "yup";
import {
  EducationalResourceStatusEnum,
  EducationalResourceTypeEnum,
} from "@/domain/educational-resource.enum";

const validationSchema = (t: TFunction) => {
  return yup.object().shape({
    categoryId: yup.string().required(t("validations.required")),
    type: yup
      .string()
      .required(t("validations.required"))
      .oneOf(
        Object.values(EducationalResourceTypeEnum),
        t("validations.invalid_format"),
      ),
    status: yup
      .string()
      .required(t("validations.required"))
      .oneOf(
        Object.values(EducationalResourceStatusEnum),
        t("validations.invalid_format"),
      ),
    languages: yup
      .array()
      .of(
        yup.object().shape({
          language: yup.string().required(t("validations.required")),
          title: yup
            .string()
            .required(t("validations.required"))
            .max(200, t("validations.max_length", { count: 200 })),
          description: yup
            .string()
            .required(t("validations.required"))
            .max(1000, t("validations.max_length", { count: 1000 })),
          url: yup
            .string()
            .required(t("validations.required"))
            .url(t("validations.invalid_format"))
            .max(500, t("validations.max_length", { count: 500 })),
        }),
      )
      .min(1, t("validations.required"))
      .required(t("validations.required")),
    attributes: yup.object().shape({
      thumbnailUrl: yup
        .string()
        .optional()
        .url(t("validations.invalid_format"))
        .max(500, t("validations.max_length", { count: 500 })),
      duration: yup.number().optional().positive().nullable(),
    }),
    priority: yup
      .number()
      .required(t("validations.required"))
      .min(0, t("validations.min_value", { minValue: 0 })),
  });
};

export type EducationalResourceFormData = InferType<
  ReturnType<typeof validationSchema>
>;

export default validationSchema;
